<template>
    <div class="contact-form form" ref="form" :class="{ processing: processing }">
        <h2 class="text-24 text-primary mb-6 font-bold">{{ translations.email_us }}</h2>

        <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">
            <div class="flex flex-wrap -mx-4">
                <div class="w-full md:w-1/2 pr-4 pl-4">
                    <ValidationProvider ref="first_name" vid="first_name" rules="required|min:2" v-slot="props" :name="translations.first_name" :slim="true">
                        <div class="relative" :class="props.classes">
                            <label class="text-12 mb-2 inline-block" for="first_name">{{ translations.first_name }}</label>
                            <input
                                type="text"
                                id="first_name"
                                class="block appearance-none w-full p-4 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm"
                                :placeholder="translations.first_name"
                                v-model="formData.first_name"
                            />
                            <span class="error text-red text-12 leading-none inline-block">{{ props.errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="w-full md:w-1/2 pr-4 pl-4">
                    <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props" :name="translations.name" :slim="true">
                        <div class="relative" :class="props.classes">
                            <label class="text-12 mb-2 inline-block" for="name">{{ translations.name }}</label>
                            <input
                                type="text"
                                id="name"
                                class="block appearance-none w-full p-4 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm"
                                :placeholder="translations.name"
                                v-model="formData.name"
                            />
                            <span class="error text-red text-12 ml-4 leading-none inline-block">{{ props.errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="flex flex-wrap -mx-4">
                <div class="w-full md:w-1/2 pr-4 pl-4">
                    <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
                        <div class="relative" :class="props.classes">
                            <label class="text-12 mb-2 inline-block" for="email">{{ translations.email }}</label>
                            <input
                                type="email"
                                id="email"
                                class="block appearance-none w-full p-4 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm"
                                :placeholder="translations.email"
                                v-model="formData.email"
                            />
                            <span class="error text-red text-12 leading-none inline-block">{{ props.errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="w-full md:w-1/2 pr-4 pl-4">
                    <ValidationProvider
                        ref="phone"
                        vid="phone"
                        :rules="{
                            required: true,
                            regex: /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/,
                        }"
                        v-slot="props"
                        :name="translations.phone"
                        :slim="true"
                    >
                        <div class="relative" :class="props.classes">
                            <label class="text-12 mb-2 inline-block" for="phone">{{ translations.phone }}</label>
                            <input
                                type="text"
                                id="phone"
                                class="block appearance-none w-full p-4 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm"
                                :placeholder="translations.phone"
                                v-model="formData.phone"
                            />
                            <span class="error text-red text-12 leading-none inline-block">{{ props.errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <!--            <div class="flex flex-wrap -mr-1 -ml-1">-->
            <!--                <div class="w-full">-->
            <!--                    <ValidationProvider ref="riziv" vid="riziv" :rules="{ required: false, regex:/(\d-\d{5}-\d{2}-\d{3})/}" v-slot="props" :name="translations.riziv" :slim="true">-->
            <!--                        <div class="relative" :class="props.classes">-->
            <!--                            <label class="text-12 mb-2 inline-block"for="riziv">{{ translations.riziv }}</label>-->
            <!--                            <the-mask :mask="'#-#####-##-###'" :masked="true" @change.native="onMaskChange" id="riziv" class="block appearance-none w-full p-4 mb-1 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm" :placeholder="translations.riziv" v-model="formData.riziv" />-->
            <!--                            <span class="error text-red text-12 leading-none inline-block ">{{ props.errors[0] }}</span>-->
            <!--                        </div>-->
            <!--                    </ValidationProvider>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="flex flex-wrap">
                <div class="w-full">
                    <ValidationProvider ref="message" vid="message" rules="required|min:5" v-slot="props" :name="translations.message" :slim="true">
                        <div class="relative" :class="props.classes">
                            <label class="text-12 mb-2 inline-block" for="message">{{ translations.message }}</label>
                            <textarea
                                id="message"
                                class="block appearance-none w-full p-4 text-base leading-normal bg-white text-gray-800 border border-gray rounded-sm"
                                :placeholder="translations.message"
                                v-model="formData.message"
                            />
                            <span class="error text-red text-12 leading-none inline-block mb-2">{{ props.errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="flex flex-wrap">
                <div class="w-full">
                    <button @click.stop="submit('/contact')" :disabled="obs.invalid" class="btn btn-green">
                        <span>{{ translations.submit }}</span>
                    </button>
                    <span v-if="compiledErrors && compiledErrors.length" class="error text-red text-12 leading-none inline-block mb-5">{{ compiledErrors[0] }}</span>
                </div>
            </div>
        </ValidationObserver>

        <div class="spinner-background">
            <div class="spinner"></div>
        </div>
    </div>
</template>

<script>
import formBase from '@mixins/formBase';
import { TheMask } from 'vue-the-mask';

export default {
    mixins: [formBase],

    components: { TheMask },

    data() {
        return {
            formData: {
                first_name: '',
                name: '',
                email: '',
                phone: '',
                message: '',
                sharpspringEndpoint: '',
                googleAnalyticsEventLabel: '',
            },
        };
    },

    mounted() {
        this.formData.sharpspringEndpoint = this.sharpspringEndpoint;
        this.formData.googleAnalyticsEventLabel = this.googleAnalyticsEventLabel;
    },

    methods: {
        onMaskChange(event) {
            this.$refs.riziv.validate(event.target.value);
        },
    },
};
</script>
